<script>
  import { getPath } from '../../utils/imageKit.ts';
  import BaseLink from '../BaseLink/BaseLink.svelte';

  let {
    name,
    image,
    link,
    showLogo,
    index,
    locationsTemplate,
    singleLocationTemplate = '',
    count,
    isNew,
    dataTestId = 'pharmacy-tile',
  } = $props();

  // Handle Image Setup
  const defaultSrc = getPath(image, { w: 100, h: 96, bg: '#ffffff' });
  const highResSrc = getPath(image, { w: 100, h: 96, bg: '#ffffff' }, 2);
</script>

{#if link && link.url}
  <BaseLink
    {...link}
    className="w-full bg-white shadow-y-lg rounded-lg relative pseudo-shadow-y-lg-hover active:shadow-active"
    dataTestId="{dataTestId}-link-tile-{index}"
  >
    <div class="px-4 py-2 flex flex-col items-center relative overflow-hidden">
      {#if isNew}
        <div class="bg-blue-malibu text-blue-navy px-6 font-bold absolute -left-5 -rotate-45">NEW</div>
      {/if}
      <div class="h-24 flex flex-col justify-center">
        {#if showLogo && image}
          <img
            class="flex-none object-contain h-24 w-25"
            loading="lazy"
            src={defaultSrc}
            alt={image.alt}
            width="100"
            height="96"
            srcset={`${defaultSrc}, ${highResSrc} 2x`}
            sizes="100px"
          />
        {:else}
          <div class="text-center font-bold">{name}</div>
        {/if}
      </div>
      {#if count}
        {#if count == 1 && singleLocationTemplate}
          <span class="text-sm text-gray-charcoal text-center" data-testid="{dataTestId}-static-tile-count-{index}"
            >{singleLocationTemplate.replace(/{{COUNT}}/, count)}</span
          >
        {:else}
          <span class="text-sm text-gray-charcoal text-center" data-testid="{dataTestId}-static-tile-count-{index}"
            >{locationsTemplate.replace(/{{COUNT}}/, count)}</span
          >
        {/if}
      {/if}
    </div>
  </BaseLink>
{:else}
  <div
    class="lg:flex w-full px-4 pt-2 pb-3 flex flex-col bg-white items-center shadow-y-lg rounded-lg"
    class:sm:hidden={index === 9}
    class:md:hidden={index === 8}
    data-testid="{dataTestId}-static-tile-{index}"
  >
    <div class="w-25 h-25 flex flex-col justify-center">
      {#if showLogo && image}
        <img
          class="flex-none object-contain h-25 w-full"
          loading="lazy"
          src={getPath(image, { w: 100, h: 100, bg: '#ffffff' })}
          alt={image.alt}
          width="100"
          height="100"
          srcset={`${getPath(image, {
            w: 100,
            h: 100,
            bg: '#ffffff',
          })}, ${getPath(image, { w: 100, h: 100, bg: '#ffffff' }, 2)} 2x`}
          sizes="100px"
        />
      {:else}
        <div class="text-center font-bold">{name}</div>
      {/if}
    </div>
    {#if count}
      {#if count == 1 && singleLocationTemplate}
        <span class="text-sm text-gray-charcoal text-center" data-testid="{dataTestId}-static-tile-count-{index}"
          >{singleLocationTemplate.replace(/{{COUNT}}/, count)}</span
        >
      {:else}
        <span class="text-sm text-gray-charcoal text-center" data-testid="{dataTestId}-static-tile-count-{index}"
          >{locationsTemplate.replace(/{{COUNT}}/, count)}</span
        >
      {/if}
    {/if}
  </div>
{/if}
